import React from "react";
import AuthLayout from "../authLayout";
import { signIn, authPassword } from "../../utils/router/constant";
import { useLocation, useNavigate } from "react-router-dom";
import Input from "../../components/common/FormFields/input";
import Button from "../../components/common/button";
import { useForm } from "react-hook-form";
import AgDetail from "../authLayout/agDetail";
import { getParamsFromURL, setParamsInURL } from "../../utils/helper";
// import api from "../../utils/interface";
// import { toast } from "react-toastify";

const Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const [entityDropdownData, setEntityDropdownData] = useState([]);
  // const [loading, setLoading] = useState(true);

  const {
    control,
    getValues,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  });

  const onSubmit = async () => {
    const firstName = getValues("first_name").trim();
    const lastName = getValues("last_name").trim();
    const email = getValues("email_id").trim();
    const fullName = `${firstName} ${lastName}`;

    const mobile = await getParamsFromURL(location, "mobile");
    // Set the query parameters
    const paramObject = {
      name: fullName,
      email: email,
    }
    if (mobile) {
      paramObject.mobile = mobile
    }
    const params = await setParamsInURL(location, paramObject);
    navigate(`${authPassword}?${params}`);
    reset();
  };

  return (
    <AuthLayout>
      <div className="auth--form--wrapper">
        <AgDetail />
        <h1 className="auth--title">Welcome! Sign Up into your account</h1>
        <p className="auth--subtitle">
          Sign Up to manage your insurance policies with ease
        </p>
        <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
          <div className="auth--form">
            <Input
              type="text"
              placeholder="First Name"
              name="first_name"
              rules={{
                required: {
                  value: true,
                  message: "Required field",
                },
                pattern: {
                  value: /^[A-Za-z\s.]*$/,
                  message: "Invalid input. Special characters and numbers not allowed",
                },
              }}
              control={control}
              errors={errors}
            />
            <Input
              type="text"
              placeholder="Last Name"
              name="last_name"
              rules={{
                required: {
                  value: true,
                  message: "Required field",
                },
                pattern: {
                  value: /^[A-Za-z\s.]*$/,
                  message: "Invalid input. Special characters and numbers not allowed",
                },
              }}
              control={control}
              errors={errors}
            />
            <Input
              type="email"
              placeholder="Email"
              name="email_id"
              rules={{
                required: {
                  value: true,
                  message: "Required field",
                },
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Invalid Email",
                },
              }}
              control={control}
              errors={errors}
            />
            <Button
              type="submit"
              variant="primary"
              label="Continue"
              disabled={!isValid}
            />
          </div>
        </form>
        <div className="or--wrapper">
          <div className="line"></div>
          <span className="or--wrapper--text">or</span>
          <div className="line"></div>
        </div>
        <Button
          onClick={() => navigate(signIn)}
          type="button"
          variant="outlined"
          label="Sign In"
        />
      </div>
    </AuthLayout>
  );
};

export default Profile;
